import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3de3bd92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row wrap"
}
const _hoisted_3 = { class: "q-pa-md row wrap q-gutter-sm" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ¡Busco factoring! ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Tutoriales ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Cerrar sesión")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "row wrap" }
const _hoisted_9 = { class: "row wrap q-gutter-sm" }
const _hoisted_10 = { class: "row wrap q-gutter-sm" }
const _hoisted_11 = { class: "full-width column wrap justify-center items-center content-center q-pa-md gap-2" }
const _hoisted_12 = { style: {"font-weight":"400","font-size":"medium"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Cerrar sesión")
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "row justify-end q-pa-sm" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "dialog-title text-center" }, [
  /*#__PURE__*/_createTextVNode("Complete el formulario y "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("te contactaremos:")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_SidebarRight = _resolveComponent("SidebarRight")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, {
          class: _normalizeClass(["navBarColor", {mobile: $setup.isMobile}])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass($setup.isMobile ? 'col-5' : 'col-2 q-my-sm')
            }, [
              _createVNode(_component_q_img, {
                class: "",
                src: "/images/IRISPP.png",
                fit: "contain",
                height: "50px"
              })
            ], 2),
            _createVNode(_component_q_space),
            (_ctx.user != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_ctx.user != null)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          (!_ctx.$route.meta.hideSidebar)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                round: "",
                                class: "rc-btn_primary--md",
                                flat: "",
                                onClick: $setup.toggleModal,
                                style: {"position":"relative"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_img, {
                                    src: "/images/busco_factoring.png",
                                    style: {"width":"65px","height":"auto","margin-right":"8px","margin-bottom":"0"}
                                  }),
                                  _hoisted_4
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!_ctx.$route.meta.hideSidebar)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 1,
                                id: "tutorial__btn",
                                round: "",
                                class: "rc__btn_hover",
                                flat: "",
                                onClick: $setup.toggleShowSideBar,
                                style: {"position":"relative"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tooltip, {
                                    anchor: "bottom middle",
                                    self: "center middle",
                                    class: "text-body"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_5
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_icon, {
                                    color: "primary",
                                    size: "md",
                                    name: "help_outline"
                                  }),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.$store.state.tutorial ? '' : 'rc_notificacion')
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_SidebarRight, { showBar: $setup.isButtonPress }, null, 8, ["showBar"]),
                          _createVNode(_component_q_btn_dropdown, {
                            flat: "",
                            class: "rc-btn_secondary--md",
                            label: _ctx.$store.state.user.name,
                            onClick: $setup.onMainClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_list, null, {
                                default: _withCtx(() => [
                                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                    clickable: "",
                                    onClick: $setup.onItemClick
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_avatar, {
                                            icon: "logout",
                                            "text-color": "primary"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_label, null, {
                                            default: _withCtx(() => [
                                              _hoisted_6
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])), [
                                    [_directive_close_popup]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["label", "onClick"])
                        ])
                      ], 512)), [
                        [_vShow, !$setup.isMobile]
                      ])
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.user != null)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_q_btn, {
                        id: "tutorial__btn",
                        round: "",
                        class: "rc__btn_hover",
                        flat: "",
                        onClick: $setup.toggleShowSideBar,
                        style: {"position":"relative"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            size: "sm",
                            name: "help"
                          }),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$store.state.tutorial ? '' : 'rc_notificacion')
                          }, null, 2)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_SidebarRight, { showBar: $setup.isButtonPress }, null, 8, ["showBar"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_q_btn, {
                        round: "",
                        class: "rc__btn_hover",
                        flat: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.menu = !$setup.menu))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            color: "primary",
                            size: "sm",
                            name: "account_circle"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_q_drawer, {
                    side: "right",
                    modelValue: $setup.menu,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.menu) = $event)),
                    width: 264,
                    breakpoint: 500,
                    style: {"color":"#3D3D3D"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_list, null, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_q_icon, {
                                      size: "md",
                                      name: "account_circle",
                                      color: "primary"
                                    }),
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$store.state.user.name), 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })), [
                            [_directive_ripple]
                          ]),
                          _hoisted_13,
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: $setup.onItemClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_avatar, {
                                    icon: "logout",
                                    "text-color": "primary"
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _hoisted_14
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_ripple],
                            [_directive_close_popup]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ], 512)), [
                  [_vShow, $setup.isMobile]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_q_btn, {
                    class: "rc-btn_primary--sm",
                    to: {name: 'register'},
                    label: "Registrarse"
                  }),
                  _createVNode(_component_q_btn, {
                    class: "rc-btn_secondary--sm q-ml-sm",
                    to: {name: 'login'},
                    label: "Ingresar"
                  })
                ]))
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: $setup.modalBuscoFactoring,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.modalBuscoFactoring) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"500px","border-radius":"25px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: ""
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _hoisted_17,
            _createVNode(_component_q_form, { onSubmit: $setup.onSubmit }, {
              default: _withCtx(() => [
                _createVNode(_component_q_scroll_area, { style: {"height":"50vh"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, { class: "q-gutter-md q-mx-lg" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_input, {
                          class: "col",
                          label: "Nombre de tu cliente",
                          outlined: "",
                          rounded: "",
                          color: "primary",
                          modelValue: $setup.formBuscoFactoring.nombre,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formBuscoFactoring.nombre) = $event)),
                          rules: $setup.formRules.nombreRule
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_q_input, {
                          label: "NIT de tu cliente",
                          outlined: "",
                          rounded: "",
                          color: "primary",
                          modelValue: $setup.formBuscoFactoring.nit,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formBuscoFactoring.nit) = $event)),
                          rules: $setup.formRules.nitRule
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_q_select, {
                          label: "Empresa",
                          outlined: "",
                          rounded: "",
                          color: "primary",
                          options: $setup.businessArray,
                          "option-value": "id",
                          "option-label": "nombre",
                          "options-selected-class": "text-white",
                          modelValue: $setup.formBuscoFactoring.empresa,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formBuscoFactoring.empresa) = $event)),
                          rules: $setup.formRules.empresaRule
                        }, null, 8, ["options", "modelValue", "rules"]),
                        _createVNode(_component_q_input, {
                          onBlur: _cache[5] || (_cache[5] = ($event: any) => ($setup.blurEvent($setup.formBuscoFactoring, 'monto', $setup.formBuscoFactoring.monto))),
                          label: "Monto de facturación por factura",
                          outlined: "",
                          rounded: "",
                          color: "primary",
                          modelValue: $setup.formBuscoFactoring.monto,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.formBuscoFactoring.monto) = $event)),
                          rules: $setup.formRules.montoRule
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_q_input, {
                          label: "Plazo de facturación (días)",
                          outlined: "",
                          rounded: "",
                          color: "primary",
                          modelValue: $setup.formBuscoFactoring.plazo,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.formBuscoFactoring.plazo) = $event)),
                          rules: $setup.formRules.plazoRule
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_q_select, {
                          label: "Periodicidad de facturación",
                          outlined: "",
                          rounded: "",
                          color: "primary",
                          options: $setup.periodicidadOptions,
                          "option-value": "value",
                          "option-label": "label",
                          "options-selected-class": "text-white",
                          modelValue: $setup.formBuscoFactoring.periodicidad,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formBuscoFactoring.periodicidad) = $event)),
                          rules: $setup.formRules.periodicidadRule
                        }, null, 8, ["options", "modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      disabled: !$setup.validateForm(),
                      label: "Enviar",
                      onClick: $setup.onSubmit,
                      class: "rc-btn_primary",
                      unelevated: ""
                    }, null, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}